import type { HeightOption } from '@/data/heights'

interface HeightRowProps {
  option: HeightOption
  selected: boolean
  onSelect: () => void
}

/** Full-width radio row used on the Height screen. */
export function HeightRow({ option, selected, onSelect }: HeightRowProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`fq-height-row${selected ? ' is-selected' : ''}`}
      onClick={onSelect}
    >
      <span className="fq-radio-dot" aria-hidden="true" />
      <span className="fq-height-body">
        <span className="fq-height-label">{option.label}</span>
        <span className="fq-height-sub">{option.subLabel}</span>
      </span>
    </button>
  )
}
